import React, { Component } from "react";
import { Img } from "../../Components/UI/UI";
import TagManager from 'react-gtm-module'
import { isMobile } from "../../Utility/Utility";
import "./TourOperators.css";

const TourOperators = () => {
  return (
    <div className="ac-wrapper-tour-operators">
      <div className="ac-tour ac-tour-1">
        <a
          target="_blank"
          href="https://israeltravel.co.il/%d7%9e%d7%a0%d7%92%d7%a0%d7%95%d7%9f-%d7%97%d7%99%d7%a4%d7%95%d7%a9-%d7%9e%d7%90%d7%a8%d7%92%d7%a0%d7%99-%d7%aa%d7%99%d7%99%d7%a8%d7%95%d7%aa/#!/"
          className="ac-tour-link"
          onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'Tour Operators', 'click_cta':'Israel Travel',}})}
        >
          <Img desktopImg={"Accomodations/1.png"} imgCss={"ac-cover-img"} />
          <div className="ac-title">
            <h3>Israel Travel</h3>
          </div>
        </a>
      </div>
      <div className="ac-tour ac-tour-2">
        <a
          target="_blank"
          href="https://touroperatorspromotingisrael.com/"
          className="ac-tour-link"
          onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'Tour Operators', 'click_cta':'Tour operators promoting israel',}})}
        >
          <Img desktopImg={"Accomodations/2.png"} imgCss={"ac-cover-img"} />
          <div className="ac-title">
            <h3>
              {/* Tour operators
              <br className="ac-show-on-cell" /> promoting israel */}
              Tour operators
              <br /> promoting israel
            </h3>
          </div>
        </a>
      </div>
      <div className="ac-tour ac-tour-3">
        <a
          target="_blank"
          href="https://www.ittaa.org.il/?lang=en"
          className="ac-tour-link"
          onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'Tour Operators', 'click_cta':'Travel Agencies and Consultants',}})}
        >
          <Img desktopImg={"Accomodations/3.png"} imgCss={"ac-cover-img"} />
          <div className="ac-title">
            <h3>Travel Agencies and Consultants</h3>
          </div>
        </a>
      </div>
    </div>
  );
};

export default TourOperators;



// WEBPACK FOOTER //
// ./src/Components/TourOperators/TourOperators.js